module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAADFBMVEVHcEyBgYGBgYGBgYGfN0gwAAAAA3RSTlMAgUCuMixEAAAAP0lEQVR4Ae2NIRIAMQwCD/j/n89WkExqG1atWIYvLAf0XvYSnDe9aLzrYTz9Gz2PhoP++iCLLIYLOq8hvIc1/GeuAkNhuYlsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/text_arrow.png
// module id = BzDv
// module chunks = 171